import { create } from "zustand";
import type { CurrentUser } from "@mestergo/shared";
import { api } from "../lib/api";

interface AuthState {
  user: CurrentUser | null;
  isLoading: boolean;
  error: string | null;
  fetchUser: () => Promise<void>;
  setUser: (user: CurrentUser) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: false,
  error: null,

  fetchUser: async () => {
    set({ isLoading: true, error: null });
    try {
      const { data } = await api.get<CurrentUser>("/auth/me");
      set({ user: data, isLoading: false });
    } catch {
      set({ error: "Failed to load user", isLoading: false });
    }
  },

  setUser: (user) => set({ user }),
}));
